import { render } from "./SendContract.vue?vue&type=template&id=2efa0c60"
import script from "./SendContract.vue?vue&type=script&lang=js"
export * from "./SendContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__